export const presetScales = {
    "Major": [
        "C4", "D4", "E4", "F4", "G4", "A4", "B4" 
    ],
    "Minor": [
        "C4", "D4", "Eb4", "F4", "G4", "Ab4", "Bb4" 
    ],
    "Major Pentatonic": [
        "C4", "D4", "E4", "G4", "A4"
    ],
    "Minor Pentatonic": [
        "C4", "Eb4", "F4", "G4", "Bb4" 
    ],
    "Major Seventh": [
        "C4", "E4", "G4", "B4" 
    ],
    "Minor Seventh": [
        "C4", "Eb4", "F4", "Bb4"  
    ],
    "Javanese Pelog": [
        "D4", "Eb4", "F4", "Ab4", "A4", "Bb4", "C4"
    ]
}